import React from 'react';
import withAuthorization from 'components/Session/withAuthorization';
import { Typography } from '@material-ui/core';
import SectionFooter from 'views/SectionFooter';
import GuideHeader from '../../components/GuideHeader';
import GuideContent from '../../components/GuideContent';
import GuideSection from '../../components/GuideSection';
import DownloadGuideButton from './DownloadGuideButton';
import ContentList from './ContentList';

const Nutrition = () => {
  return (
    <>
      <GuideHeader
        name="Nutrition"
        cdnId="app_images/nutrition-containers"
        text="Following a balanced diet is essential to your success. This is a simple guide to help you achieve your goals while supporting your nutritional needs for health and fitness. "
      />
      <GuideContent>
        <GuideSection>
          <Typography variant="h5" gutterBottom>
            NUTRITION BASICS
          </Typography>
          <Typography variant="h6" gutterBottom style={{ marginTop: 16, marginBottom: 16 }}>
            <strong>Understanding Macronutrients (Macros)</strong>
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>
              <i>Protiens</i>
            </strong>{' '}
            are essential for growth, tissue repair and is a good source of energy. Protein supplies your body with
            amino acids that are the building blocks for your cells. Found in meats, eggs, dairy, fish, legumes and
            nuts.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>
              <i>Carbohydrates (Carbs)</i>
            </strong>{' '}
            are essential as they are the preferred energy source for the body, every cell in the body can use glucose
            (which is the broken down form of starches and sugars) for energy. Found in fruits, vegetables and grains.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>
              <i>Fats</i>
            </strong>{' '}
            are essential for brain function, optimal hormone balance, cell growth and play an important role in
            metabolism. Fat supplies more than twice the calories per gram of protein or carbs and helps with the
            absorption of fat soluble vitamins throughout the body plus providing energy. Nuts, seeds, oils and fish
            offer a healthier version of monounsaturated, polyunsaturated and a few saturated fats. It is best to get a
            wide variety of healthy fats. <strong>*</strong> A key rule is to always include a protein source with each
            meal and adjust your fats and carbs depending on the day.
          </Typography>
          <Typography variant="h6" gutterBottom style={{ marginTop: 16, marginBottom: 16 }}>
            <strong>Understanding Micronutrients (Micro’s)</strong>
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            <strong>
              <i>Vitamins, minerals, and phytonutrients</i>
            </strong>{' '}
            are small-molecule food components you need in order to support your health. Eating a well balanced diet
            helps to insure you have all the nutrients required for good health. However, our bodies are still lacking
            some of the most important nutrients regardless of our diet. For your longevity it is essential to
            supplement your diet with vitamins and minerals.
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Here are some key tips:</strong>
          </Typography>
          <ContentList>
            <Typography variant="body1" gutterBottom>
              Prioritize protein with every meal
            </Typography>
            <Typography variant="body1" gutterBottom>
              Prioritize macro and micronutrients more than calories
            </Typography>
            <Typography variant="body1" gutterBottom>
              Planning ahead is key to your success
            </Typography>
            <Typography variant="body1" gutterBottom>
              Focus on nutrient-packed vegetables, fruits, whole grains, lean meats, and healthy fats
            </Typography>
            <Typography variant="body1" gutterBottom>
              Avoid high sugar and processed foods
            </Typography>
          </ContentList>

          <Typography variant="h6" gutterBottom style={{ marginTop: 16, marginBottom: 16 }}>
            <strong>Water / Hydration</strong>
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Water is the most important of all nutrients for your body. It assists in maintaining normal body
            temperature, cushions and lubricates joints, protects your spinal cord, removes wastes, makes up 75% of your
            muscles and makes up 83% of your blood. You must replace the water your body loses daily through normal
            everyday functions and when you are working out you need to replace even more water that is lost during the
            workout through sweat. Most important tip - A good goal is to drink roughly 1 oz. per pound of lean body
            weight. Stay hydrated!
          </Typography>

          <Typography variant="body1" gutterBottom paragraph>
            <strong>Tip:</strong> Start your morning with 8oz of distilled or spring water with 3-5 grams of pink
            himalayan salt and ½ squeezed lemon.
          </Typography>
        </GuideSection>
        <DownloadGuideButton storagePath="guides/nutrition-guide.pdf" type="Nutritional" />
      </GuideContent>
      <SectionFooter />
    </>
  );
};

export default withAuthorization()(Nutrition);
